export default __webpack_public_path__ + "static/media/logo1.beb935b4.png";